import { getCardTextOption, formatFocusedImage } from "./formatBaseMolecules"
import formatPageLinks from "./formatPageLinks"
import { Link } from "gatsby"
import checkForExternalLink from "./checkForExternalLink"
import { formatRegions } from "../config/regionConfig"
import formatVideo from "./formatVideo"
import formatLottieAnimation from "./formatLottieAnimation"

const dotenv = require("dotenv")
dotenv.config()
const formatCards = (
  data,
  locale = "en",
  location,
  appData = null,
  region,
  ratio = null,
  homepageSlug,
  currentSpaceId,
  products,
  siteIdentifier,
  tab
) => {
  if (data && Array.isArray(data)) {
    return data?.map(card => {
      let videoContent
      if (card?.cardLink?.video) {
        const videoData = formatVideo(card?.cardLink?.video)
        const video = videoData?.video
        const thumbnail = videoData?.thumbnail?.focalPointImage?.url
          ? videoData?.thumbnail
          : null

        videoContent = {
          transcript: videoData?.transcript,
          transcriptText: videoData?.transcriptText,
          closeTranscript: videoData?.closeTranscript,
          video,
          thumbnail,
          variant: "variant_7",
          videoProgress: data?.videoProgress,
          setVideoProgress: data?.setVideoProgress,
        }
      }

      const regions = formatRegions(card?.regions)

      let isInRegion = false

      if (regions && regions?.length > 0) {
        // if card is in region, then hide it
        const findCurrentRegion = regions.find(reg => {
          return (
            reg?.machineName?.toLowerCase() ===
            region?.machineName?.toLowerCase()
          )
        })
        if (findCurrentRegion) {
          isInRegion = true
        } else {
          // else show it
          isInRegion = false
        }
      }

      const cardLinkType = card?.cardLink?.url?.contentType
        ? card?.cardLink?.url?.contentType
        : card?.cardLink?.url?.internal?.type
        ? card?.cardLink?.url?.internal?.type
        : null

      let modalContent = null

      if (card?.modalType && card?.modalType === "Video") {
        const isVidyard =
          card?.video?.__typename === "ContentfulVidyardVideo" ? true : false
        if (card?.video?.videoUrl || card?.video?.uuid) {
          modalContent = {
            thumbnail: card?.cardImage
              ? formatFocusedImage(card?.cardImage)
              : null,
            variant: "unbounded_cards",
            video: {
              url: card?.video?.videoUrl,
              vidyard: isVidyard ? true : false,
              uuid: isVidyard && card?.video?.uuid ? card?.video?.uuid : null,
            },
          }
        }
      }

      if (card?.modalType === "Image" && card?.modalImage) {
        modalContent = {
          variant: "unbounded_cards",
          modalImage: card?.modalImage
            ? formatFocusedImage(card?.modalImage)
            : null,
        }
      }

      if (regions.length && isInRegion) {
        return
      }

      return {
        locale,
        eyebrow: card?.eyebrow,
        header: card?.header,
        text: card?.textContent
          ? getCardTextOption(card?.textContent, location)
          : null,
        image:
          card?.cardImage?.__typename === "ContentfulLottieAnimation"
            ? formatLottieAnimation(
                card?.cardImage?.srcLink || card?.cardImage?.json || null,
                { height: "100%", display: "block" },
                ratio
              )
            : card?.cardImage
            ? formatFocusedImage(card?.cardImage, card?.header)
            : null,
        cardLink:
          card?.cardLink?.video && videoContent
            ? {
                video: videoContent,
                text: card?.cardLink?.text,
              }
            : formatPageLinks(
                card?.cardLink,
                locale,
                cardLinkType,
                homepageSlug,
                currentSpaceId
              ),
        bgColor: card?.bgColor,
        modalType: card?.modalType ? card?.modalType : null,
        modalContent: modalContent ? modalContent : null,
        Link,
        contentfulId: card?.contentfulId,
        cardTags: card?.cardTags,
        isInRegion: isInRegion,
        tab: tab
      }
    })
  }
  return null
}

export default formatCards

export const formatButtons = (link, locale = "en") => {
  if (!link) {
    return null
  }

  let text

  if (link?.text) {
    text = link.text
  }

  if (!link?.text) {
    text = link?.url?.text
  }

  if (link?.url && link?.url?.url) {
    link.external = checkForExternalLink(link?.url?.url)
  }

  const url = link?.url?.url?.startsWith("http")
    ? link?.url?.url
    : locale && typeof locale === "string"
    ? `/${locale?.toLowerCase()}/${link?.url?.url}`
    : `/en/${link?.url?.url}`

  return {
    text,
    url,
    Link,
  }
}